<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "AnwerbungNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="5"></NewArticle>
</template>

<style scoped>

</style>
